<template>
  <div :class="['order_item-wrap', collapsed ? 'collapsed' : 'expanded']">
    <div class="order_item-container">
      <!-- 订单摘要 -->
      <div class="order-summary">
        <div class="order-time">
          <img src="@/assets/imgs/icons/info.svg" alt="Sisley Paris" />
          <div class="time">{{source.created_at | strLength(10) }}</div>
        </div>
        <div class="order-info">
          <div class="order-sn">订单编号：<span class="txt-bold">{{source.order_sn}}</span></div>
          <div class="order-extra">
            <div class="order-money">
              <div class="order-count">数量：{{source.total_number}}</div>
              <div class="order-amount">总计：¥{{source.total_amount | toFixed(2) }}</div>
            </div>
            <div class="order-status">
              <template v-if="source.order_status == 1">
                <button class="btn" @click="changePaymentMethod" v-if="false">修改支付方式</button>
                <button class="btn btn-black" @click="toPayOrder">立即支付</button>
              </template>
              <!-- <template v-else-if="source.state_status == 'wait_delivery'">
                <div class="status-text">订单待发货</div>
              </template> -->
              <template v-else>
                <div class="status-text status-finished">{{source.state_status}}</div>
              </template>
            </div>
          </div>
        </div>
        <button class="order-more" @click="toggle()">
          <span class="more-text">{{ collapsed ? '展开详情' : '收起详情' }}</span>
          <i class="iconfont more-arrow">&#xe636;</i>
          <i class="iconfont more-plus">{{ collapsed ? '&#xe627;' : '&#xe604;' }}</i>
        </button>
      </div>
      <!-- 订单详情 -->
      <div class="order-details" v-if="source.detail">
        <div class="module btns-tile" v-if="false">
          <div class="order-actions">
            <button class="link" @click="toCancelOrder(source)">取消订单</button>
          </div>
        </div>
        <!-- 订单信息 -->
        <div class="module">
          <div class="module-title">订单信息</div>
          <div class="txt-lines">
            <div class="txt-line">下单时间：{{ source.created_at }}</div>
            <!-- <div class="txt-line">获得积分：{{ Math.floor(source.total_amount) }}</div> -->
            <div class="txt-line">支付方式：{{ source.payment_type | typeify }}</div>
            <div class="txt-line" v-if="source.payment_at">支付时间：{{ source.payment_at }}</div>
            <div class="txt-line" v-if="source.order_remark">备注信息：{{ source.order_remark }}</div>
          </div>
        </div>
        <!-- 配送信息 -->
        <div class="module" v-if="source.detail.address_info">
          <div class="module-title">配送信息</div>
          <div class="txt-lines">
            <div class="txt-line">姓名：{{source.detail.address_info.contact}}</div>
            <div class="txt-line">联系电话：{{source.detail.address_info.mobile}}</div>
            <div class="txt-line">收货地址：{{source.detail.address_info.province}}{{source.detail.address_info.city}}{{source.detail.address_info.district}}{{source.detail.address_info.address}}</div>
          </div>
        </div>
        <!-- 发票信息 -->
        <div class="module" v-if="source.order_status != 2">
          <div class="module-title">发票信息</div>
          <template v-if="source.detail.order_invoice && source.detail.order_invoice.title">
            <div class="txt-lines">
              <div class="txt-line">发票类型：增值税电子普通发票</div>
              <div class="txt-line">抬头类型：{{source.detail.order_invoice.type != 'person'?'公司':'个人'}}</div>
              <div class="txt-line">发票抬头：{{source.detail.order_invoice.title}}</div>
              <div class="txt-line" v-if="source.detail.order_invoice.number">
                纳税人识别号：{{source.detail.order_invoice.number}}
              </div>
              <div class="txt-line" v-if="source.detail.order_invoice.phone">
                手机号码：{{source.detail.order_invoice.phone}}
              </div>
              <div class="txt-line" v-if="source.detail.order_invoice.email">电子邮箱：{{source.detail.order_invoice.email}}</div>
              <div class="no_email" v-else-if="source.channel != 0">
                <VForm class="ms-row" :model="invoiceEmail" :rule="invoiceEmailForm" ref="invoiceEmail">
                  <div class="col-xs-12">
                    <FormItem prop="email">
                      <input type="text" class="c-input c-input--fullwidth" placeholder="* 电子邮箱（发票将发送至此邮箱）" v-model.trim="invoiceEmail.email" maxlength="30" />
                    </FormItem>
                  </div>
                </VForm>
              </div>
            </div>
            <div class="invoice_btns" v-if="source.channel != 0">
              <template v-if="source.has_invoice !=0 && source.has_invoice !=5 &&!source.invoice_download_url">
                <button class="btn--primary" disabled>待开票</button>
              </template>
              <template v-else-if="source.invoice_download_url && source.has_invoice !=5">
                <button class="btn--primary" @click="sendEmail">发送邮箱</button>
              </template>
            </div>
          </template>
          <!-- <template v-if="!source.detail.order_invoice && source.order_status == 10"> -->
          <template v-if="canSendEmail && !source.detail.order_invoice">
            <div class="module-subtitle subtitle_icon"><i class="iconfont">&#xe654;</i>增值税普通电子发票</div>
            <VForm class="ms-row" :model="invoice" :rule="invoiceRule" ref="invoice">
              <div class="col-xs-12">
                <FormItem prop="type">
                  <MultiSelect v-model="invoice.type" :options="invoiceOpts" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 请选择发票类型"/>
                </FormItem>
              </div>
              <div class="col-xs-12">
                <FormItem prop="title">
                  <input type="text" class="c-input c-input--fullwidth" placeholder="* 请输入抬头名称" v-model.trim="invoice.title" maxlength="30" />
                </FormItem>
              </div>
              <div class="col-xs-12">
                <FormItem prop="id">
                  <input type="text" class="c-input c-input--fullwidth" :placeholder="invoice.type == '企业' ? '* 纳税人识别号' : '纳税人识别号（选填）'" v-model.trim="invoice.id" maxlength="30" />
                </FormItem>
              </div>
              <div class="col-xs-12">
                <FormItem prop="email">
                  <input type="text" class="c-input c-input--fullwidth" placeholder="* 电子邮箱（发票将发送至此邮箱）" v-model.trim="invoice.email" maxlength="30" />
                </FormItem>
              </div>
              <div class="col-xs-12">
                <button class="btn--primary" @click="toApplyInvoice">申请开票</button>
              </div>
            </VForm>
          </template>
        </div>
        <!-- 贺卡信息 -->
        <div class="module" v-if="source.detail.card && source.detail.card.from && source.detail.card.to">
          <div class="module-title">贺卡信息</div>
          <div class="txt-lines">
            <div class="txt-line">致：{{source.detail.card.to}}</div>
            <div class="txt-line">来从：{{source.detail.card.from}}</div>
            <div class="txt-line">内容：{{source.detail.card.content}}</div>
          </div>
        </div>
        <!-- 物流信息 -->
        <div class="module" v-if="source.express_no">
          <div class="module-title">物流信息</div>
          <div class="txt-lines">
            <div class="txt-line">物流公司：{{ source.delivery_mode }}</div>
            <div class="txt-line">物流单号：{{ source.express_no }}</div>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="module" v-if="source.detail.goods_list">
          <div class="module-title">商品信息</div>
          <div class="module-subtitle">选购商品</div>
          <div class="goods-items">
            <template v-for="outerItem in source.detail.goods_list">
              <template v-for="(innerItem, innerIndex) in outerItem.main">
                <!-- 最后一项 && 有赠品 -->
                <template v-if="innerIndex + 1 == outerItem.main.length && outerItem.gift && outerItem.gift.length">
                  <GoodsItem :base="objectify(innerItem)" size="large" :gifts="outerItem.gift" :gift-name="getAppliedRuleName(innerItem.applied_rule_ids)" :key="innerItem.id" />
                </template>
                <template v-else>
                  <GoodsItem :base="objectify(innerItem)" size="large" :key="innerItem.id" />
                </template>
              </template>
            </template>
          </div>
          <!-- 全场赠品 -->
          <template v-if="Array.isArray(source.detail.group_gifts) && source.detail.group_gifts.length">
            <div class="module-subtitle mt30">全场赠品</div>
            <div class="trial-items product_coupon__items">
              <div v-for="(item, index) in source.detail.group_gifts" :key="index" class="item-base">
                <div class="item-image">
                  <img :src="item.pic" :alt="item.name" />
                </div>
                <div class="item-intro">
                  <div class="item-info">
                    <div class="item-name">{{item.name}}</div>
                    <div class="item-count">x {{item.qty || 1}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- 积分兑换商品 -->
          <template v-if="Array.isArray(source.detail.product_coupon_sku) && source.detail.product_coupon_sku.length">
            <div class="module-subtitle mt30">{{source.detail.product_coupon_name || '尊享礼遇'}}</div>
            <div class="trial-items product_coupon__items">
              <div v-for="(item, index) in source.detail.product_coupon_sku" :key="index" class="item-base">
                <div class="item-image">
                  <img :src="item.pic" :alt="item.name" />
                </div>
                <div class="item-intro">
                  <div class="item-info">
                    <div class="item-name">{{item.name}}</div>
                    <div class="item-count">x {{item.qty || 1}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- 试用装商品 -->
          <template v-if="Array.isArray(source.detail.goods_free) && source.detail.goods_free.length">
            <div class="module-subtitle mt30">试用装商品</div>
            <div class="trial-items">
              <div v-for="(item, index) in source.detail.goods_free" :key="index" class="item-base">
                <div class="item-image">
                  <img :src="item.pic" :alt="item.name" />
                </div>
                <div class="item-intro">
                  <div class="item-info">
                    <div class="item-name">{{item.name}}</div>
                    <div class="item-count">x {{item.quantity || 1}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- 订单摘要 -->
        <div class="module" v-if="source.detail.money_info">
          <div class="kv-lines">
            <div class="kv-line">
              <div class="kv-name">商品金额</div>
              <div class="kv-value">¥{{ source.detail.money_info.total_product_price | toFixed(2) }}</div>
            </div>
            <div class="kv-line">
              <div class="kv-name">优惠金额</div>
              <div class="kv-value">-¥{{ source.detail.money_info.total_discount | toFixed(2) }}</div>
            </div>
            <!-- <div class="kv-line" v-if="source.detail.money_info.total_point_discount > 0">
              <div class="kv-name">积分抵扣</div>
              <div class="kv-value">-¥{{ source.detail.money_info.total_point_discount | toFixed(2) }}</div>
            </div> -->
            <div class="kv-line">
              <div class="kv-name">运费</div>
              <div class="kv-value" v-if="source.detail.money_info.total_ship_fee > 0">+¥{{source.detail.money_info.total_ship_fee | toFixed(2) }}</div>  
              <div class="kv-value" v-else>免费</div>
            </div>
            <div class="kv-line">
              <div class="kv-name">包装</div>
              <div class="kv-value" v-if="source.detail.money_info.total_wrap_fee > 0">+¥{{ source.detail.money_info.total_wrap_fee | toFixed(2) }}</div>
              <div class="kv-value" v-else>免费</div>
            </div>
            <div class="kv-line txt-bold">
              <div class="kv-name">总计</div>
              <div class="kv-value">￥{{source.detail.money_info.total_amount | toFixed(2) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btm-btn">
      <button class="link fold-btn" @click="toggle(true)">
        <span class="btn-text">收起详情</span>
        <i class="iconfont">&#xe636;</i>
      </button>
    </div>
    <!-- 扫码付款 -->
    <Dialog :show="dialog == 1" wrapCls="wait_pay" @hide="reCheck">
      <div class="payment-header">
        <i class="iconfont payment-icon ali-pay" v-if="source.payment_type == 'AliPay' || source.payment_type == 'HuabeiPay'">&#xe660;</i>
        <i class="iconfont payment-icon wx-pay" v-if="source.payment_type == 'WeixinPay'">&#xe65b;</i>
        <span class="payment-text">{{ source.payment_type | typeify }}支付</span>
      </div>
      <div class="txt-lines" v-if="source.total_amount">
        <div class="txt-line">支付金额：<span class="txt-bold">￥{{ source.total_amount | toFixed(2) }}</span></div>
        <template v-if="countdown && (countdown.m || countdown.s)">
          <div class="txt-line">距离二维码过期还剩<span class="txt-primary">{{countdown.m}}分{{countdown.s}}秒</span></div>
          <div class="txt-line">过期后请点击刷新重新获取二维码</div>
        </template>
        <template v-else>
          <div class="txt-line">二维码已失效</div>
          <div class="txt-line"><span class="link txt-primary" @click="refreshCode">刷新</span>并获取新二维码</div>
        </template>
      </div>
      <div class="qrcode-wrap" v-if="codeSrc">
        <template v-if="codeMode == 'image'">
          <img class="qrcode-imgage" :src="codeSrc" />
        </template>
        <template v-else-if="codeMode == 'iframe'">
          <iframe class="qrcode-iframe" :src="codeSrc" scrolling="no" align="middle" frameborder="0" seamless />
        </template>
        <div class="qrcode-mask" v-if="codeMask" @click="refreshCode">已失效</div>
      </div>
      <div class="txt-lines">
        <div class="txt-line">打开{{ source.payment_type | typeify }}扫一扫</div>
        <div class="txt-line">扫描上方二维码完成付款</div>
      </div>
    </Dialog>
    <!-- 支付结果 -->
    <Dialog :show="dialog == 2" wrapCls="pay-result" @hide="reCheck">
      <div class="txt-lines">
        <div class="txt-line txt-bold">支付结果</div>
        <div class="txt-line mt20">付款完成前请不要关闭窗口，</div>
        <div class="txt-line">完成付款后根据你的情况点击下方按钮！</div>
      </div>
      <button class="btn" @click="reCheck">已完成支付</button>
      <button class="btn btn-white" @click="toPayOrder">支付遇到问题，重新支付</button>
    </Dialog>
    <!-- 货到付款 -->
    <Dialog :show="dialog == 3" wrapCls="freight_collect" @hide="toClose">
      <div class="txt-lines">
        <div class="txt-line txt-bold">您的订单已提交成功</div>
        <div class="txt-line mt20">请您保持订单中预留的<span class="strong">电话号码畅通</span></div>
        <div class="txt-line">客服将尽快与您联系以便确认订单信息</div>
      </div>
      <button class="btn" @click="toClose">确定</button>
    </Dialog>
  </div>
</template>

<script>
import VForm from "@/components/form/my-form";
import FormItem from "@/components/form/form-item";
import 'vue-multiselect/dist/vue-multiselect.min.css';
import MultiSelect from 'vue-multiselect';
import GoodsItem from '@/components/GoodsItem.vue';
import Dialog from '@/components/Dialog.vue';
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";

export default {
  name: "OrderItem",
  components: { GoodsItem, Dialog, VForm, FormItem, MultiSelect },
  props: {
    source: {
      type: Object,
      required: true
    },
    expended: {
      type: Boolean,
      default: undefined
    }
  },
  data() {
    // 纳税人识别码
    let invoiceCode = (rule, value, callback) => {
      let invoiceType = this.invoice?.type;
      if (invoiceType == "企业" && !value) {
        callback(new Error("请输入纳税人识别码"));
      } else if (value && !/^[A-Za-z0-9]+$/.test(value)) {
        callback(new Error("纳税人识别号为数字或字母格式"));
      } else {
        callback();
      }
    };
    return {
      collapsed: true,
      invoiceOpts: ['个人', '企业'],
      invoice: { type: '个人' },
      invoiceRule: {
        title: [{ required: true, message: "请输入抬头名称", trigger: "blur"}],
        id: [{ validator: invoiceCode, trigger: "blur" }],
        email: [{ required: true, validator(rule, value, callback) {
          if (!value) {
            callback(new Error("请输入邮箱地址"));
          } else if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value)) {
            callback(new Error("邮箱格式不正确"));
          } else {
            callback();
          }
        }, trigger: "blur"}]
      },
      invoiceEmailForm: {
        email: [{ required: true, validator(rule, value, callback) {
          if (!value) {
            callback(new Error("请输入邮箱地址"));
          } else if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value)) {
            callback(new Error("邮箱格式不正确"));
          } else {
            callback();
          }
        }, trigger: "blur"}]    
      },
      invoiceEmail:{
        email:''
      },
      allowPayMethod: [],
      paymentChannel: "",
      dialog: 0,
      countdown: { m: 0, s: 0 },
      codeSrc: "",
      codeMode: "image",
      codeMask: false,
      canSendEmail:false
    }
  },
  created() {
    if (this.expended == this.collapsed) {
      this.toggle(!this.expended);
    }
    // 移动端支付方式处理
    if (utils.isWXBrowser()) {
      this.allowPayMethod = [
        { text: '微信支付', value: 'WeixinPay', iconCls: 'wx-pay', iconText: '&#xe65c;', iconSymbol: 'iconweixinzhifu' }
      ];
      this.paymentChannel = 'JSAPI';
    } else if (utils.isMobile()) {
      this.allowPayMethod = [
        { text: '支付宝支付', value: 'AliPay', iconCls: 'ali-pay', iconText: '&#xe660;', iconSymbol: 'iconzhifubao' },
        { text: '微信支付', value: 'WeixinPay', iconCls: 'wx-pay', iconText: '&#xe65c;', iconSymbol: 'iconweixinzhifu' },
        { text: '银联支付', value: 'UnionPay', iconCls: 'union-pay', iconText: '&#xe65e;', iconSymbol: 'iconyinlian' },
        { text: '花呗支付', value: 'HuabeiPay', iconCls: 'ant_credit-pay', iconText: '&#xe659;', iconSymbol: 'iconhuabei' }
      ];
      this.paymentChannel = 'MWEB';
    } else {
      this.allowPayMethod = [
        { text: '支付宝支付', value: 'AliPay', iconCls: 'ali-pay', iconText: '&#xe660;', iconSymbol: 'iconzhifubao' },
        { text: '微信支付', value: 'WeixinPay', iconCls: 'wx-pay', iconText: '&#xe65c;', iconSymbol: 'iconweixinzhifu' },
        { text: '银联支付', value: 'UnionPay', iconCls: 'union-pay', iconText: '&#xe65e;', iconSymbol: 'iconyinlian' },
        { text: '花呗支付', value: 'HuabeiPay', iconCls: 'ant_credit-pay', iconText: '&#xe659;', iconSymbol: 'iconhuabei' }
      ];
      this.paymentChannel = 'NATIVE';
    }
    // 
    // this.checkPayStatus();
  },
  mounted(){
    if(!this.source.detail.order_invoice && this.source.order_status !=2 && this.source.order_status !=7){
      this.canSendEmail = true
    }
    if(!this.source.detail.order_invoice && this.source.order_status ==7 && this.source.order_state == 25){
      this.canSendEmail = true
    }
  },
  methods: {
    toggle(collapse) {
      this.collapsed = collapse != undefined ? collapse : !this.collapsed;
      // 查询是否在小程序申请过，但还未出票,刷新订单
      if(!this.collapsed  && this.source.has_invoice === 0 && this.source.invoice_url && this.source.invoice_url != ''){
        this.invoiceQuery()
      }
    },
    objectify(item) {
      if (typeof item.collections == "string" && item.collections.length) {
        try {
          item.collections = JSON.parse(item.collections);
        } catch(err) {
          console.warn(err);
        }
      }
      return item;
    },
    // 获取订单中商品应用的促销规则名称
    getAppliedRuleName(appliedRuleStr) {
      let rules = [];
      if (appliedRuleStr && typeof appliedRuleStr == "string") {
        try {
          rules = JSON.parse(appliedRuleStr);
        } catch(err) {
          console.warn('订单应用的促销规则数据异常：', err, appliedRuleStr);
        }
      }
      let matched = rules.find(rule => rule?.type == "gift" && rule.is_special_gift == 1);
      return matched?.rule_name || '';
    },
    // 检查支付状态
    checkPayStatus() {
      // 地址参数 = 当前订单 & 已支付
      if (this.$route.query?.sn == this.source.order_sn && this.source.order_status == 3) {
        console.log('付款成功');
        this.gtmTrackPurchase();
        this.ylTrackPayment();
      }
    },
    // 
    invoiceQuery(){
      let _data = {
        order_sn: this.source.order_sn
      }
      api[types.INVOICE_QUERY](_data).then(res => {
        if (res.code == 1) { 
          if(res.data.invoice_url&&res.data.invoice_url!=''&&!this.source.detail.order_invoice){
            this.$emit('loadSource')
          }
        }
      }).catch();
    },
    // 
    toClose() {
      this.waitPayTimer && clearInterval(this.waitPayTimer);
      this.wsTimer && clearInterval(this.wsTimer);
      this.wsInstance?.close();
      this.dialog = 0;
    },
    // 扫码支付
    showWaitPay() { this.dialog = 1; },
    // 支付结果
    showPayResult() { this.dialog = 2; },
    // 货到付款
    showCashOnDelivery() { this.dialog = 3; },
    // 重新查询支付状态
    reCheck() {
      this.toClose();
      this.$router.replace({ path: `/payquery?sn=${this.source.order_sn}` });
    },
    // 支付成功处理
    showPaySuccess() {
      this.$message({ message: "支付成功", iconCls: "success" });
      this.toRefresh(1000);
    },
    // 
    toRefresh(delay = 1000 / 60) {
      this.toClose();
      setTimeout(() => {
        location.reload();
      }, delay);
    },
    // 开始制定秒数的倒计时
    startCountdown(times, callback) {
      if (isNaN(times)) return console.warn(`倒计时参数错误: ${times}`), false;
      if (typeof callback != "function") return console.warn("缺少倒计时结束回调函数"), false;
      callback(times);
      let timer = setInterval(() => {
        times--;
        if (times <= 0) {
          timer && clearInterval(timer);
        }
        callback(times, timer);
      }, 1000);
      return timer;
    },
    // 修改支付方式
    changePaymentMethod() {
      console.log(this.source);
    },
    // 立即支付
    toPayOrder() {
      // 当前的支付环境
      let { paymentChannel } = this;
      // 以前的支付方式
      let { order_sn, payment_type } = this.source;
      if (payment_type != "Offline") {
        // 
        if (payment_type == "UnionPay") {
          // TODO:: 路径需要注意
          window.open(`/pay?sn=${order_sn}&m=${payment_type}&t=${paymentChannel}`, '_blank');
          this.showPayResult();
        } else  {
          let newArgs = {
            order_sn: order_sn,
            payment_method: payment_type,
            trade_type: paymentChannel,
            again: 1
          };
          if (paymentChannel == "JSAPI") {
            newArgs.openid = this.$route.query.openid;
          } else if (payment_type == 'HuabeiPay') {
            newArgs.hb_fp_num = this.source.huabei_period;
          }
          api[types.ORDER_PAY](newArgs).then(res => {
            if (res.code == 1) {
              // 二维码方式
              if (paymentChannel == "NATIVE" && ["WeixinPay", "AliPay", "HuabeiPay"].indexOf(payment_type) != -1) {
                this.codeSrc = res.data;
                this.codeMask = false;
                if (["AliPay", "HuabeiPay"].indexOf(payment_type) != -1) {
                  this.codeMode = "iframe";
                } else {
                  this.codeMode = "image";
                }
                this.waitPayTimer && clearInterval(this.waitPayTimer);
                this.waitPayTimer = this.startCountdown(4* 60, (times, timer) => {
                  if (times > 0) {
                    this.countdown = { m: Math.floor(times/60), s: times % 60 };
                  } else {
                    this.countdown = { m: 0, s: 0 };
                    this.codeMask = true;
                    timer && clearInterval(timer);
                    this.wsTimer && clearInterval(this.wsTimer);
                    this.wsInstance && this.wsInstance?.close();
                  }
                });
                this.showWaitPay();
                this.toQueryOrder();
              } else if (paymentChannel == "JSAPI") { // utils.isWXBrowser()
                this.toCallJSAPI(res.data);
              } else { // MWEB or utils.isMobile()
                if (typeof res.data == "object") {
                  location.href = res.data.mweb_url;
                } else {
                  location.href = res.data;
                }
              }
            } else if (res.code != 2) {
              this.$message({ message: res.message, iconCls: "failure" });
            }
          }).catch(err => {
            console.warn(err);
          });
        }
      } else {
        // this.showCashOnDelivery();
      }
    },
    // 检测JSAPI调用环境
    toCallJSAPI(args) {
      if (typeof window.WeixinJSBridge == "undefined"){
        if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', () => this.onBridgeReady(args), false);
        }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', () => this.onBridgeReady(args));
            document.attachEvent('onWeixinJSBridgeReady', () => this.onBridgeReady(args));
        }
      }else{
        this.onBridgeReady(args);
      }
    },
    // JSAPI调用
    onBridgeReady(args) {
      let { appId, timeStamp, nonceStr, signType, paySign } = args;
      if (appId && timeStamp && nonceStr && signType && paySign && args.package) {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
          "appId": appId,
          "timeStamp": timeStamp,
          "nonceStr": nonceStr,
          "package": args.package,
          "signType": signType,
          "paySign": paySign
        }, function(res){
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if(res.err_msg == "get_brand_wcpay_request:ok" ){
            this.reCheck();
          } else {
            console.warn('[getBrandWCPayRequest]:: ', res);
            this.$message({ message: res.err_msg, iconCls: "failure" });
          }
        });
      } else {
        this.$message({ message: "网络异常", iconCls: "failure" });
        console.warn(args);
      }
    },
    // 
    toQueryOrder() {
      if (!this.source || !this.source.order_sn) return null;
      let wsInstance = api[types.ORDER_PAY_STATUS_QUERY](this.source.order_sn, (evt, ws) => {
        if (evt?.data) {
          try {
            let res = JSON.parse(evt.data);
            if (res?.code == 1) {
              this.reCheck();
            } else {
              console.warn(res);
            }
          } catch (err) {
            console.warn(err);
          } finally {
            this.waitPayTimer && clearInterval(this.waitPayTimer);
            this.wsTimer && clearInterval(this.wsTimer);
            wsInstance?.close();
          }
        } else {
          this.waitPayTimer && clearInterval(this.waitPayTimer);
          this.wsTimer && clearInterval(this.wsTimer);
          ws?.close();
        }
      });
      // 每隔30秒发送一次消息确保链接不断
      this.wsTimer = setInterval(() => {
        wsInstance.send(JSON.stringify({ "orderId": this.source.order_sn }));
      }, 30 * 1000);
      this.wsInstance = wsInstance;
      return wsInstance;
    },
    // 
    refreshCode() {
      this.codeMask = false;
      this.toPayOrder();
    },
    toCancelOrder() {
      console.info(this.source);
    },
    // 申请开票 => 补充发票信息
    toApplyInvoice() {
      this.$refs.invoice.validate().then(res => {
        if (res) {
          console.log(this.invoice);
          let _data = {
            order_sn: this.source.order_sn,
            title: this.invoice.title,
            number: this.invoice.id,
            email: this.invoice.email,
            type: this.invoice.type == '个人' ? 'person' : 'company'
          }
          api[types.ADD_INVOICE](_data).then(res => {
            if (res.code == 1) { 
              this.$message({ message: res.message, iconCls: "success" });
              this.$emit('loadSource')
            } else if (res.code != 2) {
              this.$message({ message: res.message, iconCls: "failure" });
            }
          }).catch();
        }
      });
    },
    // 发送邮箱
    async sendEmail() {
      let email = ''
      if(!this.source.detail.order_invoice.email){
        let res = await this.$refs.invoiceEmail.validate().then(res => res)
        if(!res) return
        email = this.invoiceEmail.email
      }else{
        email = this.source.detail.order_invoice.email
      }
      let _data = {
        order_sn: this.source.order_sn,
        email
      }
      api[types.SEND_INVOICE_EMAIL](_data).then(res => {
        if (res.code == 1) { 
          this.$message({ message: res.message, iconCls: "success" });
          this.$emit('loadSource')
        } else if (res.code != 2) {
          this.$message({ message: res.message, iconCls: "failure" });
        }
      }).catch();
    },
    // GTM Products
    gtmItemsHelper() {
      return this.source?.detail?.goods_list?.reduce((ret, curr) => {
        return {
          items: ret.items.concat(curr.main.map(item => {
            return {
              id: item.sku,
              name: item.name,
              price: item.original_price,
              quantity: item.qty,
              productType: ['collection', 'collection_sku'].indexOf(item.display_type) != -1 ? 'bundle' : item.origin_product_data?.skus?.length > 1 ? 'configured' : 'simple',
              position: ret.count
            };
          })),
          count: ret.count + curr.main.length
        }
      }, { items: [], count: 0 }).items;
    },
    // GTM 付款成功
    gtmTrackPurchase() {
      if (!window.dataLayer || !this?.source?.order_sn) return false;
      let menoy_info = this.source.detail.money_info;
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'CNY',
          purchase: {
            actionField: {
              step: 5,
              currencyCode: 'CNY',
              id: this.source.order_sn,                                                   // Order ID
              affiliation: this.paymentChannel == 'NATIVE' ? 'Desktop' : 'Mobile',        // Store name
              revenue: menoy_info.total_amount,                                           // 总金额（含增值税，含运费）
              revenueHt: menoy_info.total_amount,                                         // 总金额（不含增值税），包括运费
              tax: '0.00',                                                                // 税费
              shipping: menoy_info.total_ship_fee,                                        // 邮费
              transactionGift: 'False',                                                   // Gift
              transactionShippingService: 'SF',                                           // 快递
              transactionShippingFree: menoy_info.total_ship_fee == 0 ? 'True' : 'False', // 免邮
              transactionPayment: this.paymentMethod || '',                               // 支付方式
              coupon: '',                                                                 // 优惠码
              coupon_id: ''                                                               // 优惠券ID
            },
            products: this.gtmItemsHelper()
          }
        }
      });
    },
    // 品数监测
    ylTrackPayment() {
      if (window?.YLTrackerz?.track) {
        let menoy_info = this.source.detail.money_info;
        window?.YLTrackerz?.track({
          type: 'payment',
          orderId: this.source.order_sn,
          total: menoy_info.total_amount,
          checkout: menoy_info.total_amount,
          shipping: menoy_info.total_ship_fee,
          payment: this.paymentMethod == 'Offline' ? '2' : '1',
          platform: { 'AliPay': '支付宝', 'WeixinPay': '微信', 'UnionPay': '银联', 'HuabeiPay': '支付宝'}[this.paymentMethod] || this.paymentMethod,
          uid: this.$store.state?.userInfo?.id || ''
        });
      }
    }
  },
  filters: {
    typeify(peymentMethod) {
      let typesMap = { 'AliPay': '支付宝', 'WeixinPay': '微信', 'UnionPay': '银联', 'HuabeiPay': '支付宝', 'Offline': '货到付款' };
      return typesMap[peymentMethod];
    }
  }
}
</script>

<style lang="scss" scoped>
  .txt-bold { font-weight: 700; }
  .btn { color: #FFFFFF; background: #000000; }
  .order_item-wrap {
    font-size: 12px; color: #000000; box-sizing: border-box; background: #FFFFFE;
    .order_item-container {
      width: 100%; border:1px solid #DFDFDF; border-radius:1px; 
      .order-summary {
        padding: 1.25rem; display: flex; justify-content: flex-start; align-items: flex-start; position: relative;
        .order-time {
          width: 4rem; min-width: 4rem; position: relative;
          .time { width: 100%; position: absolute; top: 50%; left: 0; transform: translate(0, -50%); background: #FFFFFF; font-size: 12px; line-height: 14px; text-align: center; }
        }
        .order-info {
          margin-left: 1.25rem;
          .order-sn { line-height: 12px;}
          .order-extra {
            .order-money {
              display: flex; justify-content: flex-start; align-items: center; line-height: 12px; margin-top: 0.9375rem; color: #575757;
              .order-amount { margin-left: 2rem; }
            }
            .order-status {
              margin-top: 0.9375rem;
              .btn {
                padding: .5rem 0rem; width: 5.875rem; border: 1px solid #E7E7E7;
                & + .btn { margin-left: 0.625rem; }
                &.btn-black { color: #FFFFFF; background: #000000; }
              }
              .status-finished { color: #575757; }
            }
          }
        }
        .order-more {
          position: absolute; top: 1.25rem; right: 1.25rem; cursor: pointer;
          .more-text { display: none; line-height: 16px; }
          .more-arrow { display: none; transform: rotate(90deg); transition: transform 0.1s ease-in; }
          .more-plus { color: #9A9A9A; }
        }
      }
      .order-details {
        padding: 0 1.25rem; transition: height 0.2s ease-in;
        .module {
          border-top: 1px solid #D7D8D8; padding-bottom: 1.25rem;
          .order-actions { margin-top: 1.25rem; }
          .module-title { margin-top: 1.25rem; font-size: 14px; color: #000000; font-weight: 700; }
          .module-subtitle {
            margin-top: 0.625rem;
            &.mt30 { margin-top: 30px; }
            &.subtitle_icon {
              display: flex; justify-content: flex-start; align-items: center; margin-bottom: 1.25rem;
              .iconfont { margin-right: 0.5rem; }
            }
          }
          .txt-lines {
            margin-top: 0.625rem; font-size: 12px; color: #575757;
            .txt-line { line-height: 30px; }
          }
          .invoice_btns {
            margin-top: 30px;
            button[disabled] { background: #CCC; border: none; color: #666; cursor: not-allowed; }
          }
          & /deep/ .form-group { width: 20rem; max-width: 100%; }
          & .no_email /deep/ .form-group { margin-bottom: 0;margin-top: 30px;}
          .goods-items { margin-top: 0.625rem; }
          .trial-items {
            margin-top: 20px;
            // 商品信息基本结构布局
            .item-base {
              width: 100%; margin-top: 20px; display: flex; justify-content: flex-start; align-items: flex-start;
              &:first-child { margin-top: 0; }
              .item-image { width: 60px; min-width: 60px; height: 80px; }
              .item-intro {
                margin-left: 20px; width: calc(100% - 80px); height: 80px; display: flex; flex-direction: column; justify-content: center;
                .item-info {
                  display: flex; justify-content: space-between; align-items: center;
                  .item-name { white-space: normal; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
                  .item-count { font-size: 12px; color: #999; min-width: 2rem; text-align: right; }
                }
              }
            }
          }
          // 
          .kv-lines {
            font-size: 12px; color: #5E5E5E; margin-top: 1.25rem;
            .kv-line {
              display: flex; justify-content: space-between; align-items: center; line-height: 24px;
              &.txt-bold {
                font-size: 14px; color: #222222;
              }
            }
          }
        }
      }
    }
    .btm-btn {
      display: none; justify-content: center;
      .fold-btn {
        margin-top: 0.625rem; text-decoration: none; display: flex; justify-content: center; align-items: center;
        .iconfont { transform: rotate(-90deg); }
      }
    }
    &.collapsed {
      .order_item-container {
        .order-details { height: 0; overflow: hidden; }
      }
    }
    &.expanded {
      .order_item-container {
        .order-summary {
          .order-more {
            .more-arrow { transform: rotate(270deg); }
          }
        }
        .order-details { height: auto; }
        .fold-btn { display: block; }
      }
      .btm-btn { display: flex; }
    }
    // 付款扫码
    ::v-deep .wait_pay .dialog-container {
      width: 470px; height: 570px;
      .dialog-body {
        flex-direction: column; justify-content: flex-start; align-items: center;
        .payment-header {
          display: flex; justify-content: center; align-items: center; margin-top: 56px; width: 100%;
          .payment-icon {
            font-size: 40px;
            &.ali-pay { color: #4F9BF3; }
            &.wx-pay { color: #54A802; }
          }
          .payment-text { font-size: 20px; color: #333333; margin-left: 10px; }
        }
        .txt-lines {
          width: 100%; text-align: center; margin-top: 6px;
          .txt-line { font-size: 14px; color: #666666; }
          .txt-bold { font-size: 25px; color: #C4172E; }
          .txt-primary { font-size: inherit; color: #C4172E; margin: 0 6px; }
        }
        .qrcode-wrap {
          width: 190px; height: 190px; margin: 20px auto; position: relative;
          .qrcode-imgage { width: 100%; }
          .qrcode-iframe { width: 190px; height: 190px; padding: 20px; }
          .qrcode-mask {
            position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); cursor: pointer;
            display: flex; justify-content: center; align-items: center; color: white; font-size: 20px;
          }
        }
      }
    }
    // 付款结果
    ::v-deep .pay-result .dialog-container {
      width: 470px; max-width: 90%; height: 310px;
      .dialog-body {
        flex-direction: column; justify-content: flex-start; align-items: center;
      }
      .txt-lines { width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin-top: 64px; }
      .txt-line { width: 100%; text-align: center; font-size: 12px; color: #666666; line-height: 24px; }
      .txt-bold, .strong { font-size: 16px; font-weight: 700; color: #333333; }
      .btn { width: 300px; margin-top: 20px; padding: 0.8125rem 0;  }
      .btn-white { background: #FFFFFF; color: #333333; border: 1px solid #C0C0C0; }
    }
    // 货到付款
    ::v-deep .freight_collect .dialog-container {
      width: 470px; max-width: 90%; height: 258px;
      .dialog-body {
        flex-direction: column; justify-content: flex-start; align-items: center;
      }
      .txt-lines { width: 100%; display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin-top: 64px; }
      .txt-line { width: 100%; text-align: center; font-size: 12px; color: #333333; line-height: 24px; }
      .txt-bold, .strong { font-size: 16px; font-weight: 700; color: #333333; }
      .strong { font-size: 12px; }
      .btn { width: 300px; margin-top: 20px; }
    }
  }
  @media screen and (min-width: 64em) {
    .order_item-wrap {
      .order_item-container {
        .order-summary {
          align-items: center;
          .order-info {
            margin-left: 2rem; display: flex; justify-content: space-between; align-items: center;
            .order-extra {
              display: flex; flex-direction: row-reverse; justify-content: space-between; align-items: center;
              .order-money {
                margin-top: 0; margin-left: 5rem;
                .order-amount { margin-left: 5rem; }
              }
              .order-status {
                margin-top: 0; margin-left: 3.125rem; display: flex; flex-direction: column-reverse;
                .btn {
                  margin-top: 0.5rem;
                  & + .btn { margin-left: 0; }
                }
              }
            }
          }
          .order-more {
            display: flex; justify-content: center; align-items: center;
            .more-text, .more-arrow { display: inline-block; }
            .more-plus { display: none; }
          }
        }
        .order-details {
          .module {
            .trial-items {
              .item-base {
                .item-image { width: 80px; height: 106px; }
                .item-intro {
                  height: 106px;
                  .item-info {
                    justify-content: flex-start;
                    .item-name { width: 385px; }
                    .item-count { display: block; }
                  }
                }
              }
            }
            .kv-lines {
              .kv-line {
                width: 40%; margin-left: 60%;
              }
            }
          }
        }
      }
    }
  }
</style>